import { Tooltip } from 'antd'
import classNames from 'classnames'
import { MyForm } from '~/components/ui/MyForm'
import InputArea from '../InputArea'
import { QuestionCircleOutlined } from '@ant-design/icons'
import styles from '../AiForm.module.css'
import { ucPromptAtom } from './atom'
import { useAtom } from 'jotai'

export const UcPropmtComp = () => {
  const [ucPrompt, setUcPrompt] = useAtom(ucPromptAtom)

  return (
    <MyForm.Item
      label={
        <span>
          负面描述{' '}
          <Tooltip
            placement="topLeft"
            arrowPointAtCenter
            title="负面描述填写你不想在创作中加入的东西"
          >
            <QuestionCircleOutlined />
          </Tooltip>
        </span>
      }
      className={classNames(styles.borderLessFormItem, '!mb-8')}
    >
      <InputArea
        placeholder={'请输入不想出现在画面中的内容，支持中英文输入'}
        className={styles.colorLessTextArea}
        value={ucPrompt}
        onChange={setUcPrompt}
      />
    </MyForm.Item>
  )
}
